/* eslint-disable @typescript-eslint/no-explicit-any */
import { ButtonERP, SearchInput } from "@finanedi.es/storybook"
import { GetDepartamentoByFiltersParamsProps } from "api/Departamento.service"
import { SortingCriteria } from "api/interfaces/SortingCriteria"
import { Skeleton } from "primereact/skeleton"
import { Dispatch, SetStateAction, useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

export default ({
  isLoading,
  sortingCriteria,
  skipCount,
  maxResultCount,
  totalCount,
  serviceQuery,
  openDepartamenteModal,
  resetPagination,
}: {
  isLoading: boolean
  sortingCriteria?: SortingCriteria
  skipCount?: GetDepartamentoByFiltersParamsProps["SkipCount"]
  maxResultCount?: GetDepartamentoByFiltersParamsProps["MaxResultCount"]
  totalCount?: number
  serviceQuery: Dispatch<SetStateAction<GetDepartamentoByFiltersParamsProps>>
  openDepartamenteModal?: () => void
  resetPagination?: () => void
}) => {
  const { t } = useTranslation()
  const [nombre, setNombre] =
    useState<GetDepartamentoByFiltersParamsProps["Nombre"]>()

  const queryFixer = (
    queryParams: GetDepartamentoByFiltersParamsProps
  ): GetDepartamentoByFiltersParamsProps => {
    const remesaParams = {
      Nombre: queryParams.Nombre,
      MaxResultCount: queryParams.MaxResultCount,
      SkipCount: queryParams.SkipCount,
      SortingCriteria:
        queryParams.SortingCriteria?.property &&
        queryParams.SortingCriteria?.sort
          ? `${queryParams.SortingCriteria.property} ${queryParams.SortingCriteria.sort}`
          : "CreationTime DESC",
    }
    const fixedQueryParams = Object.fromEntries(
      Object.entries(remesaParams).filter(
        ([_key, value]) => value || value === 0 // eslint-disable-line @typescript-eslint/no-unused-vars
      )
    )
    return fixedQueryParams
  }
  const query = {
    Nombre: nombre,
    SortingCriteria: sortingCriteria,
    SkipCount: skipCount,
    MaxResultCount: maxResultCount,
  }
  const handleQuery = () => {
    serviceQuery(queryFixer(query))
  }

  useEffect(() => {
    resetPagination?.()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nombre])

  useEffect(() => {
    handleQuery()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    nombre,
    skipCount,
    maxResultCount,
    sortingCriteria?.property,
    sortingCriteria?.sort,
  ])

  return (
    <>
      <div className='!tw-px-6 tw-flex tw-flex-col lg:tw-flex-row tw-justify-between tw-items-center tw-pb-4 tw-pt-6 tw-shadow-3xl tw-rounded-t-xl mb-1 tw-bg-white'>
        <p className='tw-whitespace-nowrap tw-text-xl tw-text-text tw-my-auto tw-flex tw-flex-row tw-gap-3 tw-items-center'>
          {t("gestionUsuarios.departamentos.title")}
          {isLoading ? (
            <Skeleton className='!tw-h-5 !tw-w-8 !tw-mx-1' />
          ) : (
            <span>{`(${totalCount})`}</span>
          )}
        </p>
        <div className='tw-flex tw-w-full tw-justify-center lg:tw-justify-end tw-mt-1 sm:tw-mt-0'>
          <div className='!tw-w-fit tw-flex tw-items-center !tw-flex-row tw-justify-end tw-flex-wrap'>
            <div className='tw-grid tw-gap-3 sm:tw-flex sm:tw-flex-row sm:tw-grid-cols-1 tw-items-center tw-w-fit'>
              <SearchInput
                placeholder={`${t(
                  "gestionUsuarios.departamentos.placeholderSearchDept"
                )}`}
                onChange={(ev: string) => {
                  resetPagination?.()
                  setNombre(ev)
                }}
                inputValue={nombre}
                className='tw-h-10 tw-w-full'
              />
              <div className='tw-flex tw-gap-2'>
                <ButtonERP
                  customize={{
                    type: "secondary",
                    size: "md",
                  }}
                  label={`${t("gestionUsuarios.departamentos.addDepartament")}`}
                  onClick={openDepartamenteModal}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
